import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Root = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  maxWidth: 280,
}));

const TooltipHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(1),
}));

const TooltipImage = styled('img')(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: 4,
  objectFit: 'cover',
  backgroundColor: theme.palette.background.dark,
}));

const TooltipTitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'MedievalSharp',
  fontSize: '1rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

const TooltipSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Merriweather',
  fontSize: '0.7rem',
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
}));

const TooltipStats = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(0.5),
  marginTop: theme.spacing(1),
}));

const TooltipStat = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(0.5),
  backgroundColor: theme.palette.background.main,
  borderRadius: 4,
}));

const StatLabel = styled(Typography)(({ theme }) => ({
  fontFamily: 'Merriweather',
  fontSize: '0.6rem',
  color: theme.palette.text.secondary,
  textTransform: 'uppercase',
}));

const StatValue = styled(Typography)(({ theme }) => ({
  fontFamily: 'MedievalSharp',
  fontSize: '0.9rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export default function MonsterTooltipContent({ monster }) {
  if (!monster) return null;

  return (
    <Root>
      <TooltipHeader>
        {monster.img && (
          <TooltipImage src={monster.img} alt={monster.name} />
        )}
        <Box>
          <TooltipTitle>{monster.name}</TooltipTitle>
          <TooltipSubtitle>
            {monster.size} {monster.type}
            {monster.alignment && `, ${monster.alignment}`}
          </TooltipSubtitle>
        </Box>
      </TooltipHeader>
      <TooltipStats>
        <TooltipStat>
          <StatLabel>AC</StatLabel>
          <StatValue>{monster.ac || '—'}</StatValue>
        </TooltipStat>
        <TooltipStat>
          <StatLabel>HP</StatLabel>
          <StatValue>{monster.hp || '—'}</StatValue>
        </TooltipStat>
        <TooltipStat>
          <StatLabel>CR</StatLabel>
          <StatValue>{monster.cr}</StatValue>
        </TooltipStat>
        <TooltipStat>
          <StatLabel>STR</StatLabel>
          <StatValue>{monster.strength || '—'}</StatValue>
        </TooltipStat>
        <TooltipStat>
          <StatLabel>DEX</StatLabel>
          <StatValue>{monster.dexterity || '—'}</StatValue>
        </TooltipStat>
        <TooltipStat>
          <StatLabel>CON</StatLabel>
          <StatValue>{monster.constitution || '—'}</StatValue>
        </TooltipStat>
      </TooltipStats>
    </Root>
  );
}
